import {
	ChangeDetectorRef,
	Component,
	Inject,
	ElementRef,
	EventEmitter,
	Pipe,
	PipeTransform,
	ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';
import {RestServiceImpl} from "../immerdrin/rest.service.impl";
import {RestService} from "../immerdrin/rest.service.interface";
import {AuthService} from "../../shared/auth.service";
import {SessionService} from "../../shared/session.service";
import {LoggerService} from "../../shared/logger.service";
import {oase_config} from "../../../environments/environment";
import {BreadcrumbService} from "../../shared/breadcrumb/breadcrumb.service";
import {OaseDeleteDialogComponent} from "../immerdrin/oase.delete.component";
import {Tabelle} from "../immerdrin/tabelle/tabelle";
import {FormControl} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {Subject} from "rxjs";
import {SelectFilterUtil} from "../immerdrin/select-filter.util";
import {FlexModule,MediaObserver} from "@ngbracket/ngx-layout";
import {KategorieInsertEditComponent} from "./kategorie.insertEdit.component";
import {Kategorie} from "./kategorie.model";
import { Datei } from "../datei/datei.model";
import {
	GalleryModule,
	Image, ModalGalleryConfig, ModalGalleryRef,
	ModalGalleryService
} from '@ks89/angular-modal-gallery';
import {HttpClient} from "@angular/common/http";
import {APIConfigService} from "../../api.config.service"; import {AngularMaterial2Module} from "../../app.module.material";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

const PATH_FILE = 'app/protected/kategorie/kategorie.component.ts';
const OBJ_LNG_NAME = 'kategorie';
const BACKEND_PATH_PREFIX = 'kategorie';

@Pipe({
    name: 'dataPipeKategorie',
    standalone:true

})
export class DataTablePipeKategorie implements PipeTransform {
  constructor(private _logger: LoggerService) { }
  transform(array: Kategorie[], query: string): Kategorie[] {
    this._logger.log(PATH_FILE + ' - transform BEGIN');
    this._logger.log(PATH_FILE + ' - transform array: ', array);
    this._logger.log(PATH_FILE + ' - transform query: ', query);
    if (query) {
      return array.filter((value: Kategorie, index: number, arr: Kategorie[]) =>
        value.bezeichnung.toLowerCase().indexOf(query.toLowerCase()) > -1
      );
    }
    return array;
  } // transform
} // class DataTablePipe


@Component({
    selector: 'oase-kategorie',
    templateUrl: './kategorie.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,
	imports: [AngularMaterial2Module, L10nTranslatePipe, GalleryModule, FlexModule]

})
export class KategorieComponent extends Tabelle<Kategorie> {

	// rechte: Kernrecht[] = new Array<Kernrecht>();

	_selectsuche: string[] = new Array<string>();

 	kategorieTyp: number;
  	kategorieId: string;
	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	ladedatenKategorien: boolean = true;

  	aktuellbilder: Datei[] = Array<Datei>();

	maxSortierung: number = 1;


	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public http: HttpClient,
		private galleryService: ModalGalleryService,
		// public copyService: CopyService,// https://angular.io/guide/component-interaction#parent-and-children-communicate-via-a-service
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		// public dragulaService: DragulaService,
		public dialog: MatDialog,
		public media: MediaObserver,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public apiConfigService: APIConfigService,
		public _logger: LoggerService) {


		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService, {
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/kategorie",
				PATH_FILE: PATH_FILE,
				DEFAULT_SORT_COLUMN: "sortierung",
				extraDataForAdding: { }
			}
		);

		// console.log("constructor")

		this.displayedColumns = [
			'bezeichnung', 'sortierung',
			'admin',
		];

		this.title.setTitle(this.getTitle());
		// this.translation.translationChanged.subscribe(() => {
		//   this.title.setTitle(this.getTitle());
		  // this.setDropzoneTexte();
		// });

		this.setKategorieData();

		this.breadcrumbService.addFriendlyNameForRoute('/protected/kategorie', this.translation.translate('kategorie.typ'));
		this.breadcrumbService.addFriendlyNameForRoute('/protected/'+this.kategorieId+'kategorie',
			this.translation.translate(this.kategorieId+'kategorie.typ'));

	}

	private setKategorieData() {
		this.kategorieTyp = this.router.url.indexOf("news") !== -1 ? 0 :
			(this.router.url.indexOf("dokumente") !== -1 ? 1 :
				(this.router.url.indexOf("vertraege") !== -1 ? 2 :
					(this.router.url.indexOf("kategorie") !== -1 ? 3 : 0)));

		this.kategorieId = this.router.url.indexOf("news") !== -1 ? "news" :
			(this.router.url.indexOf("dokumente") !== -1 ? "dokumente" :
				(this.router.url.indexOf("vertraege") !== -1 ? "vertraege" : "news"));

		// console.log(this.kategorieTyp);
		// this.kategorieTyp = 2;
	}

	getTitle() {
		return this.translation.translate('kategorie.title') + ' - ' + this.translation.translate('project.title');
	}

	extraInit() {
		super.extraInit();
	}

	public afterDataIsLoaded() {
		// console.log("begin:"+this.dataSource.content)
        if(this.dataSource.content.length > 0) {
			this.maxSortierung=this.dataSource.content.length;
			if (this.kategorieTyp !== 3) {
				let datei = this.dataSource.content[0].datei;
				let image: Image = new Image(0, {
					img: this.authService.getAuthUrl(datei.url + '/w2500'),
					description: ""
				});
				this.imagePopupImages = [image];
			}
		}
        // this._logger.log(PATH_FILE + ' - getKategorien End', this.dataSource.content);
        this.ladedatenKategorien = false;
        this.ladedaten = this.ladedatenKategorien;
	}

	createNewElement() {
		return new Kategorie();
	}

	loeschenSpalteName() {
		return "bezeichnung";
	}

	getApiParams() {
		this.setKategorieData();
		return "seite/"+this.kategorieTyp;
	}

//   zeigeHinzufuegenMaske() {
// //    this.inserteditForm.reset();
//     this.neu = true;
//     this.aktuell = new Kategorie();
//     this.aktuell.typ=this.kategorieTyp;


	vorHinzufuegen(element) {
	    element.typ=this.kategorieTyp;
	    element.maxSortierung=this.maxSortierung;
	}

	zeigeLoeschenMaske(element: any) {
		this._zeigeLoeschenMaske(element, OaseDeleteDialogComponent);
	}

	zeigeHinzufuegenMaske() {
		this._zeigeHinzufuegenMaske(KategorieInsertEditComponent);
	}

	zeigeBearbeitenMaske(element) {
		element.maxSortierung=this.maxSortierung;
		this._zeigeBearbeitenMaske(element, KategorieInsertEditComponent);
	}

	openImagePopup(kategorie: Kategorie) {
		this.isImagePopupOpen = true;
		let bild: Datei = this.getDatei(kategorie);
		this._logger.log(PATH_FILE + ' - openImagePopup kategorie:', kategorie);
		this._logger.log(PATH_FILE + ' - openImagePopup bild:', bild);
		if (bild != null) {
		  	let title = bild.name;
			let image: Image = new Image(0, { img: this.authService.getAuthUrl(bild.url + '/w2500'), description: title });
			this._logger.log(PATH_FILE + ' - openImagePopup image:', image);
			this.imagePopupImages = [...[image]];
			const dialogRef: ModalGalleryRef = this.galleryService.open({
				id: 1,
				images: this.imagePopupImages,
				currentImage: image,
				libConfig: {
					slideConfig: {
						infinite: false,
						sidePreviews: {show: false}
					},
					previewConfig: {visible: false},
					dotsConfig: {visible: false}
				}
			} as ModalGalleryConfig) as ModalGalleryRef;
		}
	}

	closeImagePopup() {
		this.imagePopupImages = new Array<Image>();
	}

	getDatei(kategorie: Kategorie): Datei {
		return kategorie.datei;
	  }
}

// import { BreadcrumbService } from '../../shared/breadcrumb/breadcrumb.service';
// import { DateiArt } from '../datei/dateiart.model';
// import { DateiArtDetails } from '../datei/dateiartdetails.model';
// import { oase_config } from '../../../environments/environment';
// import { AuthService } from '../../shared/auth.service';
// import { Httpstatus } from '../../shared/response/httpstatus.model';
// import { Kernantwort } from '../../shared/response/kernantwort.model';
// import { SessionService } from '../../shared/session.service';
// import { Datei } from '../datei/datei.model';
// import { Kategorie } from './kategorie.model';
// import { Component, Pipe, PipeTransform, Inject, ViewChild } from '@angular/core';
// import { NgForm } from '@angular/forms';
// import { Response, ResponseType, RequestOptionsArgs, Headers } from '@angular/http';
// // import { MatDialog, MatSnackBar } from '@angular/material';
// import { MatDialog } from '@angular/material/dialog';
// import { MatSnackBar } from '@angular/material/snack-bar';
// import { Title } from '@angular/platform-browser';
// import { ActivatedRoute, Router, ParamMap } from '@angular/router';
// import { Image } from 'angular-modal-gallery';
// import { DropzoneConfigInterface, DropzoneComponent } from 'ngx-dropzone-wrapper';

// import { LoggerService } from '../../shared/logger.service';


// import { Observable } from 'rxjs/Rx';
// import {TableWith2Dialogs} from "../immerdrin/tablewith2dialogs";
//
// const PATH_FILE = 'app/protected/kategorie/kategorie.component.ts';
// const OBJ_LNG_NAME = 'kategorie';
// const BACKEND_PATH_PREFIX = 'kategorie/';
// const REST_API_BASE =
//   ( window.location.hostname == 'localhost' ? oase_config.restapi.schema + '://' : '' ) + // z.B. http://
//   ( window.location.hostname == 'localhost' ? oase_config.restapi.host : '' ) + // z.B. masterproject.oase.at
//   ( window.location.hostname == 'localhost' ? ( oase_config.restapi.port ? ':' + oase_config.restapi.port : '' ) : '' ) + '/' + // z.B. :80/ oder /
//   oase_config.restapi.path + '/'; // z.B. masterproject/
// const REST_API =
//   REST_API_BASE +
//   BACKEND_PATH_PREFIX; // z.B. kategorie/
// const REST_API_DATEI = REST_API_BASE + 'datei/';
//
// @Pipe({ name: 'dataPipeKategorie' })
// export class DataTablePipeKategorie implements PipeTransform {
//   constructor(private _logger: LoggerService) { }
//   transform(array: Kategorie[], query: string): Kategorie[] {
//     this._logger.log(PATH_FILE + ' - transform BEGIN');
//     this._logger.log(PATH_FILE + ' - transform array: ', array);
//     this._logger.log(PATH_FILE + ' - transform query: ', query);
//     if (query) {
//       return array.filter((value: Kategorie, index: number, arr: Kategorie[]) =>
//         value.bezeichnung.toLowerCase().indexOf(query.toLowerCase()) > -1
//       );
//     }
//     return array;
//   } // transform
// } // class DataTablePipe
//
// @Component({
//   selector: 'oase-kategorie',
//   templateUrl: './kategorie.component.html',
//   styleUrls: ['./kategorie.component.css']
// })
// export class KategorieComponent extends TableWith2Dialogs {
//   OBJ_LNG_NAME = OBJ_LNG_NAME; // Wird benötigt das Konstanten nicht im Template refernziert werden können.
//   DateiArt = DateiArt;  // Damit ein ENUM auch im Template verwendet werden kann.
//   dateiArtDetails: DateiArtDetails = new DateiArtDetails(); // Wird benötigt da Angular2 nicht auf statische Methoden zugreifen kann!?
//   data: Kategorie[] = Array<Kategorie>();
//   kategorieTyp: number;
//   kategorieId: string;
//   search: string = '';
//   aktuell: Kategorie = null;
//   aktuellbilder: Datei[] = Array<Datei>();
//   maxSortierung: number = 1;
//   neu: boolean = false;
//   ladedaten: boolean = true;
//   ladedatenKategorien: boolean = true;
//   dialogrunningajaxcall: boolean = false;
//   seconddialogrunningajaxcall: boolean = false;
//   isImagePopupOpen: boolean = false;
//   imagePopupPointer: number = 0;
//   imagePopupImages: Image[] = new Array<Image>();
//   @ViewChild(Md2DataTable) md2datatable: Md2DataTable;
//   @ViewChild('insertedit') insertedit: Md2Dialog;
//   @ViewChild('inserteditForm') inserteditForm: NgForm;
//   @ViewChild('delete') delete: Md2Dialog;
//   @ViewChild('uploadImage') uploadImage: Md2Dialog;
//   @ViewChild('chooseImage') chooseImage: Md2Dialog;
//
//   public dropzoneConfig: DropzoneConfigInterface = {
//     url: REST_API_DATEI + 'hinzufuegen',
//     maxFiles: 1, // Nur eine Datei kann hochgeladen werden
//     uploadMultiple: false, // Mehrfachupload möglich
//     parallelUploads: 1, // Wie viele Dateien gleichzeitig hochgelagen werden können
//     addRemoveLinks: true,
//     acceptedFiles: this.dateiArtDetails.BILDEXTENSIONS, // Erlaubte Dateiendungen
//     headers: {
//       'Authorization': 'Bearer ' + this.authService.getToken() // Den AuthToken beim Bildupload anhängen
//     },
//     init: function() {
//       this.on("processing", function(file: any) {
//         console.log(PATH_FILE + ' - DropzoneConfigInterface init on processing file: ', file);
//         console.log(PATH_FILE + ' - DropzoneConfigInterface init on processing this.options.url: ', this.options.url);
//       });
//       this.on("sending", function(file: any, xhr: any, formData: any) {
//         console.log(PATH_FILE + ' - DropzoneConfigInterface init on sending file: ', file);
//         console.log(PATH_FILE + ' - DropzoneConfigInterface init on sending xhr: ', xhr);
//         console.log(PATH_FILE + ' - DropzoneConfigInterface init on sending formData: ', formData);
//         console.log(PATH_FILE + ' - DropzoneConfigInterface init on sending this.options.url: ', this.options.url);
//       });
//       this.on("addedfile", function(file: any) {
//         if(this.files.length > 1) this.removeFile(this.files[0]); // Immer nur eine Datei für den Upload ermöglichen: https://github.com/enyo/dropzone/issues/1020#issuecomment-126557207
//         if (!file.type.match(/image./)) {
//         }
//       });
//     }
//   };
//
//
//   constructor(
//     private route: ActivatedRoute,
//     private router: Router,
//     private breadcrumbService: BreadcrumbService,
//     public dialog: MatDialog,
//     public snackBar: MatSnackBar,
//     public authService: AuthService,
//     private authHttp: AuthHttp,
//     public locale: LocaleService,
//     public translation: TranslationService,
//     public sessService: SessionService,
//     public title: Title,
//     public _logger: LoggerService) {
//     super(locale, translation, _logger, PATH_FILE);
//
//     // Set document title.
//     this.title.setTitle(this.getTitle());
//     this.translation.translationChanged.subscribe(() => {
//       this.title.setTitle(this.getTitle());
//       this.setDropzoneTexte();
//     });
//
//     this.kategorieTyp = this.router.url.indexOf("news") !== -1 ? 0 :
//       (this.router.url.indexOf("dokumente") !== -1 ? 1 :
//         (this.router.url.indexOf("vertraege") !== -1 ? 2 :
//           (this.router.url.indexOf("kategorie") !== -1 ? 3 : 0)));
//
//     this.kategorieId = this.router.url.indexOf("news") !== -1 ? "news" :
//       (this.router.url.indexOf("dokumente") !== -1 ? "dokumente" :
//         (this.router.url.indexOf("vertraege") !== -1 ? "vertraege" : "news"));
//
//     this.breadcrumbService.addFriendlyNameForRoute('/protected/kategorie', this.translation.translate('kategorie.typ'));
//     this.breadcrumbService.addFriendlyNameForRoute('/protected/'+this.kategorieId+'kategorie',
//         this.translation.translate(this.kategorieId+'kategorie.typ'));
//
//     this.getKategorien();
//     this.markDialogAsClosed(null);
//     // this._logger.log(PATH_FILE + ' - dropzoneConfig: ', this.dropzoneConfig);
//
//     this.sessService.logSessionInfos(PATH_FILE);
//   }
//
//
//   private setDropzoneTexte(): void {
//     this.dropzoneConfig.dictDefaultMessage=this.translation.translate('dropzone.dictDefaultMessage');
//     this.dropzoneConfig.dictFallbackMessage=this.translation.translate('dropzone.dictFallbackMessage');
//     this.dropzoneConfig.dictFallbackText=this.translation.translate('dropzone.dictFallbackText');
//     this.dropzoneConfig.dictFileTooBig=this.translation.translate('dropzone.dictFileTooBig');
//     this.dropzoneConfig.dictInvalidFileType=this.translation.translate('dropzone.dictInvalidFileType');
//     this.dropzoneConfig.dictResponseError=this.translation.translate('dropzone.dictResponseError');
//     this.dropzoneConfig.dictCancelUpload=this.translation.translate('dropzone.dictCancelUpload');
//     this.dropzoneConfig.dictCancelUploadConfirmation=this.translation.translate('dropzone.dictCancelUploadConfirmation');
//     this.dropzoneConfig.dictRemoveFile=this.translation.translate('dropzone.dictRemoveFile');
//     this.dropzoneConfig.dictMaxFilesExceeded=this.translation.translate('dropzone.dictMaxFilesExceeded');
//   }
//
//   private getKategorien() {
//     this._logger.log(PATH_FILE + ' - getKategorien Begin');
//
//     this.ladedatenKategorien = true;
//     this.ladedaten = this.ladedatenKategorien;
//
//     this.http
//       .get(this.REST_API + 'liste/' + this.kategorieTyp)
//        // Um mehrfachaufrufe zu verhindern
//       .subscribe(
//       data => {
//         this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
//         this.data = data.json() as Kategorie[];
//         if(this.data.length>0)
//           this.maxSortierung=this.data.length;
//         this._logger.log(PATH_FILE + ' - getKategorien End');
//         this.ladedatenKategorien = false;
//         this.ladedaten = this.ladedatenKategorien;
//         // Initial-Sortierung da dies über Attribute im HTML nicht korrekt funktioniert
//         if(this.md2datatable != null && (this.md2datatable.getSort() == null || this.md2datatable.getSort().sortBy == null || !this.md2datatable.getSort().sortBy))
//           this.md2datatable.setSort('sortierung', 'asc');
//         this.closeOpenDialog();
//       },
//       err => {
//         this.ladedatenKategorien = false;
//         this.ladedaten = this.ladedatenKategorien;
//         ErrorHelper.handleError(err,"Fehler beim holen der Kategorien",this._logger, this.translation)
//       },
//       () => {
//         this.ladedatenKategorien = false;
//         this.ladedaten = this.ladedatenKategorien;
//         this._logger.log(PATH_FILE + ' - Holen der Kategorien abgeschlossen')
//       }
//       );
//   } // getKategorien
//
//   private getBilder() {
//     this._logger.log(PATH_FILE + ' - getBilder Begin');
//
//     this.seconddialogrunningajaxcall = true;
//
//     this.http
//       .get(REST_API_DATEI + 'liste/BILD')
//        // Um mehrfachaufrufe zu verhindern
//       .subscribe(
//       data => {
//         this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
//         this.seconddialogrunningajaxcall = false;
//         this._logger.log(PATH_FILE + ' - got answer data: ' + data);
//         this.aktuellbilder = data.json() as Datei[];
//         this._logger.log(PATH_FILE + ' - getBilder End');
//       },
//       err => {
//         this.seconddialogrunningajaxcall = false;
//         ErrorHelper.handleError(err,"Fehler beim holen der Bilder",this._logger, this.translation)
//       },
//       () => {
//         this.seconddialogrunningajaxcall = false;
//         this._logger.log(PATH_FILE + ' - Holen der Bilder abgeschlossen')
//       }
//       );
//   } // getBilder
//
//   speichern(kategorie: Kategorie, snacknachricht: string, reloadData: boolean = true) {
//     this._logger.debug(PATH_FILE + ' - speichern BEGIN');
//     this._logger.debug(PATH_FILE + ' - speichern - kategorie: ', JSON.stringify(kategorie));
//     this._logger.debug(PATH_FILE + ' - speichern - this.aktuell: ', this.aktuell);
//     this._logger.debug(PATH_FILE + ' - speichern - reloadData: ', reloadData);
//
//     this.dialogrunningajaxcall = this.isDialogOpen() ? true : false;
//
//     let aktuell: Kategorie = JSON.parse(JSON.stringify(this.aktuell));
//     this._logger.debug(PATH_FILE + ' - speichern - aktuell AFTER: ', aktuell);
//     this._logger.log(PATH_FILE + ' - speichern - http: ' + REST_API + (this.neu ? 'hinzufuegen/0' : 'bearbeiten/' + aktuell.id));
//
//     let request = null;
//     if(this.neu)
//       request = this.http.post(REST_API + 'hinzufuegen/0', JSON.stringify(aktuell));
//     else
//       request = this.http.put(REST_API + 'bearbeiten/' + this.aktuell.id, JSON.stringify(aktuell));
//
//     request
//        // Um mehrfachaufrufe zu verhindern
//       .subscribe(
//       data => {
//         this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
//         if(reloadData) {
//           this.getKategorien();
//         }
//         else {
//           this.ladedaten = false;
//           this.closeOpenDialog();
//         }
//         this.openSnackBar(snacknachricht);
//         this._logger.log(PATH_FILE + ' - speichern End');
//       },
//       err => {
//         this.handleError(err, "Fehler beim speichern (" + (this.neu ? "neu" : "bearbeiten") + ") des Kategories")
//       });
//   } // speichern
//
//   speichernAend(kategorie: Kategorie) {
//     this._logger.log(PATH_FILE + ' - speichernAend BEGIN');
//     this._logger.log(PATH_FILE + ' - speichernAend - kategorie: ', kategorie);
//
//     let snacknachricht = this.translation.translate((this.neu ? 'allgemein.daten.hinzugefügt' : 'allgemein.daten.geändert'), { typ: this.translation.translate('kategorie.typ') });
//     this.speichern(kategorie, snacknachricht);
//   } // speichernAend
//
//   loeschen(kategorie: Kategorie) {
//     this.dialogrunningajaxcall = this.isDialogOpen() ? true : false;
//     this._logger.log(PATH_FILE + ' - loeschen BEGIN');
//     this._logger.debug(PATH_FILE + ' - loeschen - kategorie: ', JSON.stringify(kategorie));
//
//     this._logger.log(PATH_FILE + ' - loeschen - http: ' + REST_API + 'loeschen/' + kategorie.id);
//     this.http
//       .delete(REST_API + 'loeschen/' + kategorie.id)
//        // Um mehrfachaufrufe zu verhindern
//       .subscribe(
//       data => {
//         this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
//         this._logger.log(PATH_FILE + ' - got answer data: ', data);
//         this.getKategorien();
//         this._logger.log(PATH_FILE + ' - loeschen End');
//       },
//       err => ErrorHelper.handleError(err,"Fehler beim löschen des Kategories",this._logger, this.translation)
//       );
//   } // loeschen
//
//   bildHochladen(uploadImageContainer: DropzoneComponent, config: DropzoneConfigInterface) {
//     this._logger.log(PATH_FILE + ' - bildHochladen BEGIN');
//     this._logger.log(PATH_FILE + ' - bildHochladen uploadImageContainer: ', uploadImageContainer);
//
//     this._logger.log(PATH_FILE + ' - bildHochladen config.url: ', config.url);
//
//     this.seconddialogrunningajaxcall = true;
//     uploadImageContainer.config=config;
//     uploadImageContainer.directiveRef.dropzone().processQueue();
//   } // bildHochladen
//
//
//   bildHochladenOnError(args: any) {
//     this.seconddialogrunningajaxcall = false;
//     console.log('bildHochladenOnError:', args);
//     this.handleError(args[1], "Fehler beim Upload des Bildes");
//   }
//
//   bildHochladenOnSuccess(args: any) {
//     console.log('bildHochladenOnSuccess:', args);
//     let datei: Datei = args[1];
//     console.log('bildHochladenOnSuccess - datei:', datei);
//     console.log('bildHochladenOnSuccess - this.aktuell 1 (geändert: ', this.aktuell);
//
//     if(datei !== null && datei[0] !== null) {
//       this.aktuell.datei = datei[0];
//     }
//     this.closeSecondOpenDialog();
//     this.seconddialogrunningajaxcall = false;
//   }
//
//   bildHochladenOnCanceled(args: any) {
//     this.seconddialogrunningajaxcall = false;
//     console.log('bildHochladenOnCanceled:', args);
//   }
//
//   bildHochladenProcessQueue(args: any) {
//     console.log('bildHochladenProcessQueue:', args);
//   }
//
//   bildAuswaehlen(datei: Datei) {
//     this._logger.log(PATH_FILE + ' - bildAuswaehlen BEGIN');
//     this._logger.log(PATH_FILE + ' - bildAuswaehlen this.aktuell: ', this.aktuell);
//     this._logger.log(PATH_FILE + ' - bildAuswaehlen datei: ', datei);
//
//     if(datei !== null) {
//       this.aktuell.datei = datei;
//     }
//     this.closeSecondOpenDialog();
//   } // bildAuswaehlen
//
//   entferneBild(kategorie: Kategorie): void {
//     kategorie.datei = null;
//   } // entferneBild
//
//   public handleError (error: Response | any, prefix: string = "handleError") {
//     this._logger.log(PATH_FILE + ' - handleError - ' + prefix + ': ', error);
//
//     this.dialogrunningajaxcall = false;
//
//     let fehler = new Kernantwort();
//     if (error instanceof Response) {
//       try {
//         fehler = error.json();
//         if(error.status==0 && !error.ok && error.type==ResponseType.Error && error.statusText.length==0) {
//           fehler.httpstatus = new Httpstatus();
//           fehler.httpstatus.name = 'vermutlich 503er Service Temporarily Unavailable';
//           fehler.httpstatus.number = 500;
//         }
//       } catch (e) {
//         fehler.messagehtml = this.translation.translate('allgemein.fehler');
//         this._logger.error(PATH_FILE + ' - ERROR ' + error.status + ': ' + prefix + ' (' + error.statusText + ' (' + error.status + ')' + '): ', error.text());
//       }
//     } else {
//       fehler = new Kernantwort();
//       fehler.message = error.message ? error.message : error.toString();
//     }
//
//     if(!fehler.messagehtml)
//       fehler.messagehtml = fehler.message;
//
//     if(fehler && fehler.httpstatus && fehler.httpstatus.number == 500) {
//       this._logger.error(PATH_FILE + ' - ' + prefix + ':' + fehler.messagehtml);
//       fehler.messagehtml = this.translation.translate('allgemein.fehler');
//       this._logger.error(PATH_FILE + ' - ERROR 500: ' + prefix + ' (' + fehler.httpstatus.name + ' (' + fehler.httpstatus.number + ')' + '): ', fehler);
//     } else {
//       this._logger.info(PATH_FILE + ' - ' + prefix + ': ', fehler);
//     }
//
//     // Nach dem der Fehler fertig erstellt wurde die entsprechende Fehler variable setzten
//     this.setzeFehler(fehler);
//
//     // Das token mit dem vom Server neu gelieferten erneuern:
//     this.authService.storeNewToken(error);
//
//     return Observable.throw(fehler.message);
//   }
//
//   zeigeBearbeitenMaske(kategorie: Kategorie) {
//     this._logger.log(PATH_FILE + ' - zeigeBearbeitenMaske kategorie:', kategorie);
//     this.neu = false;
// //    this.aktuell = kategorie;
//     this.aktuell = JSON.parse(JSON.stringify(kategorie));
//     this._logger.log(PATH_FILE + ' - zeigeBearbeitenMaske this.aktuell:', this.aktuell);
//     this.doOpenDialog(this.insertedit, { disableClose: true });
//   } // zeigeBearbeitenMaske
//
//   zeigeHinzufuegenMaske() {
// //    this.inserteditForm.reset();
//     this.neu = true;
//     this.aktuell = new Kategorie();
//     this.aktuell.typ=this.kategorieTyp;
//     this._logger.log(PATH_FILE + ' - zeigeHinzufuegenMaske this.aktuell:', this.aktuell);
//     this.doOpenDialog(this.insertedit, { disableClose: true });
//   } // zeigeHinzufuegenMaske
//
//   zeigeLoeschenMaske(kategorie: Kategorie) {
//     this.aktuell = JSON.parse(JSON.stringify(kategorie));
//     this.doOpenDialog(this.delete, { disableClose: true });
//   } // zeigeLoeschenMaske
//
//   zeigeBilduploadMaske() {
//     this._logger.log(PATH_FILE + ' - zeigeBilduploadMaske');
//     this.doOpenSecondDialog(this.uploadImage, { disableClose: true });
//   } // zeigeBilduploadMaske
//
//   zeigeBildauswahlMaske() {
//     this._logger.log(PATH_FILE + ' - zeigeBildauswahlMaske');
//     this.getBilder();
//     this.doOpenSecondDialog(this.chooseImage);
//   } // zeigeBildauswahlMaske
//
//   leereHelper(resetForms: boolean = true) {
//     this._logger.log(PATH_FILE + ' - leereHelper BEGIN');
//     this.aktuell = null;
//     if(this.isDialogOpen())
//       this.fehlerDialog = null
//     if(this.isSecondDialogOpen())
//       this.fehlerSecondDialog = null
//     this.neu = false;
//     this.dialogrunningajaxcall = false;
//     if(resetForms) {
//     }
//   }
//
//   extraprocessing() {
//     this.aktuellbilder = Array<Datei>(); // Temp-Array mit Bildern wieder löschen
//   }
//
//   getTitle() {
//     return this.translation.translate('kategorie.title') + ' - ' + this.translation.translate('project.title');
//   }
//
//   openSnackBar(message: string, action: string = null) {
//     this.snackBar.open(message, action, {duration: 5 * 1000});
//   }
//
//   getBildVerkleinertUrl(datei: Datei, zusatz: string = ''): string {
//     if(datei != null)
//       return this.authService.getAuthUrl(datei.url + zusatz);
//     return null;
//   }
//
//   getDatei(kategorie: Kategorie): Datei {
//     return kategorie.datei;
//   }
//
//   openImagePopup(kategorie: Kategorie) {
//     let bild: Datei = this.getDatei(kategorie);
//     if(bild !== null) {
//       let title = bild.name;
//       let image: Image = new Image(this.authService.getAuthUrl(bild.url + '/w2500'), null, title, null); // img, thumb, description, extUrl (https://ks89.github.io/angular-modal-gallery.github.io/features#Image)
//       this.isImagePopupOpen = true;
//       this.imagePopupImages = new Array<Image>();
//       this.imagePopupImages.push(image);
//       this.imagePopupPointer  = 0;
//     }
//   }
//
//   closeImagePopup() {
//     this.isImagePopupOpen = false;
//     this.imagePopupImages = new Array<Image>();
//     this.imagePopupPointer  = 0;
//   }
// }
